import { parse, parseObject, parseSize } from '@apparel/core/utils';

export { parse, parseSize, parseObject };

export default parse;
